/* ============
 * Add Batch Log Component
 * ============
 *
 * This is the component for creating batch log
 */
import Forms from '../../utils/forms/forms';
import clientService from '../../services/client';
import { mapGetters, mapMutations } from 'vuex';
import productGroupService from './../../services/product-group';
import catalogueTransformer from './../../transformers/catalogue';

export default {
  data() {
    return {
      loading: false,
      form: new Forms({
        productGroupId: {
          value: '',
          type: 'select',
        },
        actionCode: {
          value: '',
          type: 'select',
        },
        name: {
          value: '',
          type: 'text',
        },
        versionId: {
          value: '',
          type: 'text',
        },
        issuedAt: {
          value: '',
          type: 'date',
        },
        validFrom: {
          value: '',
          type: 'date',
        },
        validTo: {
          value: '',
          type: 'date',
        },
        reference: {
          value: '',
          type: 'textarea',
        },
        note: {
          value: '',
          type: 'textarea',
        },
      }),
    };
  },

  props: {
    clientId: {
      required: true,
      type: Number,
    },
  },

  computed: {
    ...mapGetters({
      productGroups: 'allProductGroups',
    }),
  },
  created() {
    this.loading = true;
    productGroupService.all()
    .then(() => {
      this.loading = false;
    })
    .catch(() => {
      this.loading = false;
    });
  },
  mounted() {
    const actionCodes = [
      { id: 'Add', name: this.$t('static.clients.catalogues.actionCodes.add') },
      { id: 'Update', name: this.$t('static.clients.catalogues.actionCodes.update') },
      { id: 'Replace', name: this.$t('static.clients.catalogues.actionCodes.replace') },
      { id: 'Delete', name: this.$t('static.clients.catalogues.actionCodes.delete') },
    ];
    this.form.setOptions('actionCode', actionCodes);
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    /**
     * This method will be called when saving the form.
     */
    save() {
      this.form.loading = true;
      const data = Object.assign({}, this.form.data(), { clientId: this.clientId });
      clientService.sendCatalogue(catalogueTransformer.send(data))
      .then(() => this.closeModal())
      .catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },

    /*
    * Closes the modal
    */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },

  watch: {
    productGroups() {
      this.form.setOptions('productGroupId', this.productGroups.all);
    },
    'form.productGroupId': function (value) {
      const productGroup = this.productGroups.all.find(group => +group.id === +value);
      console.log(productGroup);
      this.form.name = productGroup.name || '';
    },
  },

  components: {
    VForm: require('../form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/sendCatalogue/sendCatalogue.js